export type EventType = 'online' | 'onSite' | 'ALL';
export type EventDuration = '1' | '2' | '3' | 'ALL';
export type IncompleteAddress = 'true' | 'ALL';
export type Source =
  | 'scoringFit'
  | 'competitionCorner'
  | 'manual'
  | 'hyrox'
  | 'maboxdecross'
  | 'ALL';

export type QueryFilters = {
  type?: EventType;
  duration?: EventDuration;
  source?: Source;
  startDate?: Date;
  name?: string;
  endDate?: Date;
  page?: string;
  size?: string;
  incompleteAddress?: IncompleteAddress;
  selectedDepartements?: Array<string>;
  view?: 'list' | 'map';
};

export type EventFilters = {
  type?: EventType;
  name?: string;
  duration?: EventDuration;
  source?: Source;
  startDate?: Date;
  endDate?: Date;
  page: number;
  size: number;
  incompleteAddress?: IncompleteAddress;
  selectedDepartements?: Array<string>;
  view?: 'list' | 'map';
};

export type SavedSearch = {
  label: string;
  filters: EventFilters;
};

export type EventItem = {
  _id: number;
  name: string;
  incompleteAddress: boolean;
  type: Exclude<EventType, 'ALL'>;
  startDate: Date;
  endDate: Date;
  location: string;
  eventLink: string;
  departement: string;
  departementCode?: string;
  departementName?: string;
  city?: string;
  zipCode: string;
  createdAt: Date;
  updatedAt: Date;
  source: Exclude<Source, 'ALL'>;
  duration: Exclude<EventDuration, 'ALL'>;
};

export const eventTypes: Array<{
  value: EventType;
  label: string;
}> = [
  { value: 'ALL', label: 'ALL' },
  { value: 'online', label: 'Online' },
  { value: 'onSite', label: 'On Site' },
];

export const eventDurations: Array<{
  value: EventDuration;
  label: string;
}> = [
  { value: 'ALL', label: 'ALL' },
  { value: '1', label: '1J' },
  { value: '2', label: '2J' },
  { value: '3', label: '3J' },
];

export const incompleteAddressValues: Array<{
  value: IncompleteAddress;
  label: string;
}> = [
  { value: 'ALL', label: 'ALL' },
  { value: 'true', label: 'Oui' },
];

export const sourceValues: Array<{
  value: Source;
  label: string;
}> = [
  { value: 'ALL', label: 'ALL' },
  { value: 'scoringFit', label: 'ScoringFit' },
  { value: 'competitionCorner', label: 'CompetitionCorner' },
  { value: 'manual', label: 'Manuel' },
  { value: 'hyrox', label: 'Hyrox' },
  { value: 'maboxdecross', label: 'Ma Box de Cross' },
];
